import { createI18n } from 'vue-i18n';

// i18n locales
import locales from './locales.js';

/**
 * Shared vue-i18n instance. Exported so it can be used both as a Vue plugin
 * (main.js) and from plain JS modules that need translations (e.g. services).
 */
const i18n = createI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: locales,
});

export default i18n;
